import React from 'react';

import { GQL } from '@aline/graphql';
import {
  Building2,
  Calendar1,
  Mail,
  MapPinHouse,
  User as UserIcon,
  UserSquare,
} from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

type CannedIconProps = SimpleIconInterface & { disabled?: boolean };

function makeIcon(Icon: typeof Calendar1) {
  return function CannedIcon(props: CannedIconProps): JSX.Element {
    const { className, dataCy, height, stroke, strokeWidth, style, width } = props;
    return (
      <Icon
        className={className}
        data-cy={dataCy}
        height={height ?? 18}
        stroke={stroke ?? 'currentColor'}
        strokeWidth={strokeWidth}
        style={style}
        width={width ?? 18}
      />
    );
  };
}

export const DateSignedIcon = makeIcon(Calendar1);
export const UserNameIcon = makeIcon(UserIcon);
export const UserEmailIcon = makeIcon(Mail);
export const UserTitleIcon = makeIcon(UserSquare);
export const AddressIcon = makeIcon(MapPinHouse);
export const CompanyIcon = makeIcon(Building2);

export const CANNED_ICON_BY_VARIANT: Record<GQL.CannedFieldVariant, React.FC<CannedIconProps>> = {
  [GQL.CannedFieldVariant.Address]: AddressIcon,
  [GQL.CannedFieldVariant.Company]: CompanyIcon,
  [GQL.CannedFieldVariant.DateSigned]: DateSignedIcon,
  [GQL.CannedFieldVariant.UserEmail]: UserEmailIcon,
  [GQL.CannedFieldVariant.UserName]: UserNameIcon,
  [GQL.CannedFieldVariant.UserTitle]: UserTitleIcon,
};
